module.exports = ".align *{\n    vertical-align: middle;\n}\n\n.logo-congreso {\n    margin-right: 1rem;\n}"